import { makeAutoObservable } from 'mobx'
import { RootStore } from 'stores'
import { IFilter } from 'types/common/query'
import { handleError } from 'API'
import {
  countDocumentTypes,
  createDocumentType,
  getDocumentTypeDetail,
  getDocumentTypes,
  updateDocumentType
} from 'API/documentType'
import { IDocumentType } from 'interfaces/documentType'

export default class DocumentTypeStore {
  rootStore: RootStore

  documentTypes: IDocumentType[] = []
  documentTypesLength: number = 0
  documentTypeDetail: IDocumentType = {}

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  async fetchDocumentTypes(filter: IFilter<IDocumentType> = {}): Promise<IDocumentType[]> {
    try {
      const documentTypes: IDocumentType[] = await getDocumentTypes(filter)
      this.documentTypes = documentTypes
      return documentTypes
    } catch (error: any) {
      handleError(error as Error, 'stores/cms/cmsDocumentTypeStore.ts', 'fetchDocumentTypes')
      return []
    }
  }

  async fetchCMSDocumentTypeList(filter: IFilter<IDocumentType> = {}): Promise<void> {
    try {
      const [documentTypeList, documentTypeCount] = await Promise.all([
        this.fetchDocumentTypes(filter),
        countDocumentTypes(filter?.where ?? {})
      ])
      this.documentTypes = documentTypeList
      this.documentTypesLength = documentTypeCount
    } catch (error: any) {
      handleError(error as Error, 'stores/cms/cmsDocumentTypeStore.ts', 'fetchCMSDocumentTypeList')
    }
  }

  async fetchDocumentTypeDetail(id: string, filter: IFilter<IDocumentType> = {}): Promise<void> {
    try {
      const documentType: IDocumentType = await getDocumentTypeDetail(id, filter)
      this.documentTypeDetail = documentType
    } catch (error: any) {
      handleError(error as Error, 'stores/cms/cmsDocumentTypeStore.ts', 'fetchDocumentTypeDetail')
    }
  }

  async createNewDocumentType(documentType: IDocumentType): Promise<void> {
    try {
      const newDocumentType: IDocumentType = await createDocumentType(documentType)
      this.documentTypeDetail = newDocumentType as IDocumentType
    } catch (error: any) {
      handleError(error as Error, 'stores/cms/cmsDocumentTypeStore.ts', 'createDocumentType')
    }
  }

  async updateExistedDocumentType(id: number, documentType: IDocumentType): Promise<void> {
    try {
      await updateDocumentType(id, documentType)
    } catch (error: any) {
      handleError(error as Error, 'stores/cms/cmsDocumentTypeStore.ts', 'updateDocumentType')
    }
  }

  selectDocumentType(id: number): void {
    if (!id) {
      this.documentTypeDetail = {}
      return
    }
    this.documentTypeDetail = this.documentTypes.find(documentType => documentType?.id === id) ?? {}
  }

  resetStore(): void {
    this.documentTypeDetail = {}
    this.documentTypes = []
  }
}
